/**
 * "Not Applicable" sentinel — used as the first value of
 * `checkboxes` / `multipleChoice` / `files` responses to flag that
 * the exhibitor explicitly opted the task out for their stand.
 *
 * Custom-report rendering inspects this sentinel value.
 */
export const NOT_APPLICABLE_TEXT = "N/A";

/**
 * How the "Not Applicable" opt-out is DISPLAYED in report tables (`N/A`),
 * as opposed to the `NOT_APPLICABLE_TEXT` sentinel that flows through the
 * data + partner feed. Detection stays on the sentinel; only table output
 * uses this short form.
 */
export const NOT_APPLICABLE_DISPLAY = "N/A";

/**
 * Full-word display of the "Not Applicable" opt-out in the task drawer's
 * RESPONSE section and the response-history modal (matches the drawer's
 * "Not Applicable" status chip). Report tables keep the short
 * `NOT_APPLICABLE_DISPLAY`; detection keeps the `NOT_APPLICABLE_TEXT`
 * sentinel.
 */
export const NOT_APPLICABLE_FULL_DISPLAY = "Not Applicable";
